import React from "react";
import { BookOpen, Database, BarChart2, Globe, AlertTriangle } from "lucide-react";

const METHODOLOGY_PILLARS = [
  {
    icon: <BookOpen size={20} />,
    code: "GHG Protocol",
    title: "Scope 3 Category 1 Aligned",
    desc:
      "Follows the GHG Protocol Corporate Value Chain (Scope 3) Standard for purchased goods and services — the globally accepted framework for spend-based carbon accounting.",
    tag: "Global Standard",
  },
  {
    icon: <BarChart2 size={20} />,
    code: "PCAF Standard",
    title: "PCAF Proxy Method",
    desc:
      "Compatible with the Partnership for Carbon Accounting Financials (PCAF) Standard, enabling financial institutions to assess and disclose financed emissions.",
    tag: "Finance Aligned",
  },
  {
    icon: <Database size={20} />,
    code: "EXIOBASE MRIO",
    title: "Multi-Regional Input-Output Database",
    desc:
      "Emission factors sourced from EXIOBASE — a detailed multi-regional input-output (MRIO) database covering 44 countries and 163 industry sectors.",
    tag: "Data Source",
  },
  {
    icon: <Globe size={20} />,
    code: "India Datasets",
    title: "India-Specific Factor Calibration",
    desc:
      "Supplemented with India-specific datasets from CEA (Central Electricity Authority), MoEFCC, and IEA to accurately reflect India's energy and emissions profile.",
    tag: "India Context",
  },
];

export default function FeaturesGrid() {
  return (
    <section className="methodology-section" id="methodology">
      <div className="landing-container">
        <div className="section-label">METHODOLOGY</div>
        <h2 className="section-title">
          A Rigorous Methodology, Simplified
        </h2>
        <p className="section-sub">
          GreenSetu applies internationally recognised frameworks and databases
          to produce credible, reproducible carbon risk estimates — at MSME scale.
        </p>

        <div className="methodology-grid">
          {METHODOLOGY_PILLARS.map((pillar, i) => (
            <div key={i} className="methodology-card">
              <div className="methodology-card-top">
                <div className="methodology-card-icon">{pillar.icon}</div>
                <span className="methodology-card-tag">{pillar.tag}</span>
              </div>
              <div className="methodology-card-code">{pillar.code}</div>
              <h3 className="methodology-card-title">{pillar.title}</h3>
              <p className="methodology-card-desc">{pillar.desc}</p>
            </div>
          ))}
        </div>

        {/* Constraint disclaimer — prominent */}
        <div className="methodology-disclaimer">
          <div className="methodology-disclaimer-icon">
            <AlertTriangle size={18} />
          </div>
          <div>
            <strong>Important Methodology Constraint</strong>
            <p>
              GreenSetu outputs are <strong>screening estimates</strong> based on spend-based proxy
              methods. They are <strong>not</strong> verified GHG inventories and do not constitute
              ISO&nbsp;14064 compliant reporting. Results should be interpreted as indicative risk
              assessments to guide further due diligence, not as audited carbon accounts.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
